module.exports = {"370572402":"经济开发区直属乡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370572.json
// module id = 1397
// module chunks = 0